import { render, staticRenderFns } from "./ShopMenu.vue?vue&type=template&id=591eec9f&scoped=true&"
import script from "./ShopMenu.vue?vue&type=script&lang=js&"
export * from "./ShopMenu.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenu.vue?vue&type=style&index=0&id=591eec9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591eec9f",
  null
  
)

export default component.exports